import React, { ChangeEvent } from "react";
import { useState, useEffect, useFormContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Purchase } from "models/PurchaseModel";
import { Item, itemKeys, emptyItem } from "models/ItemModel";
import { Inventory, inventoryKeys } from "models/InventoryModel";
import AsyncSelect from "react-select/async";
import { Calculate } from "helpers/CalculateHelpers"
import { Extract } from "helpers/ExtractHelper";
import { ItemInventory } from "models/ItemInventoryModel";
import { CommonDataColumn } from "models/BaseModel";


const PurchaseForm: React.FC = () => {
const width = { product:30, skucode:20, utncode:20,  purchase:15, cost:15 }
const [formId, formName] = [Code.Form.Id.PURCHASE, Code.Form.Name.PURCHASE];
const {keyId, setKeyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
const [formData, setFormData] = useState<Purchase>({});
const [itemInventoryData, setItemInventoryData] = useState<ItemInventory[]>([]); 
const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
const [statusOptions, setStatusOptions] = Hooks.Form.Options();
const [supplierOptions, setSupplierOptions] = Hooks.Form.Options();
const [selectedProduct, setSelectedProduct] = useState<OptionType | null>(null);
const [localSkucode, setLocalSkucode] = useState<string>('');

Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
const Privilege = Hooks.Privilege.List(formId);
Hooks.Privilege.HasOpen(Privilege);
   
useEffect(() => {
  Files.Json.API(Code.File.SUPPLIER, Code.Option.Common.SELECT, setSupplierOptions, setError);
  Files.Json.API(Code.File.DOCTOR, Code.Option.Common.NA, setDoctorOptions, setError);
  Files.Json.Http(Code.File.SEGMENT, Code.Option.Common.SELECT, setSegmentOptions, setError);
  Files.Json.API(Code.File.OPTION+Code.Group.ORDER_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
  
  API.Data.GetByKeyId<Purchase>(formName, keyId, setLoading, setError)
    .then(async(data) => { if(data) {
      setActiveId(data.purchase_active); 
      const clientData = await API.Data.getClientNameNumber(data.client_id);
      const formData = await Form.Map.Data(data);
      setFormData((prevData) => ({
        ...prevData,
        ...formData,
        ...clientData,
      }));
      Utility.Storage.Set(Code.Form.Name.PURCHASE,data.purchase_id);
      callItemList(data.purchase_id);

      console.log("purchase form data", data);

  }})
  if(keyId===Code.Key.NEW) {
    setFormData((prev) => ({...prev, segment_id: Code.Option.Segment.OPTICAL}));
  }
  setLoading(false);
}, []);

const callItemList = async (purchaseId: number | undefined) => {
  if (!purchaseId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.ITEM, 200, Name.Item.Id, Code.Option.Sort.ASC, {
    fields: Utility.Join.Fields([
      Name.Item.Id, 
      Name.Item.Date, 
      Name.Product.Name, 
      Name.Item.Gross,
      Name.Item.DiscountA,
      Name.Item.Taxable,
      Name.Item.Tax1A,
      Name.Item.Net,
      Name.Item.SKU,
      Name.Item.UTN,
      Name.Inventory.Data,
      Name.Inventory.Purchase, 
      Name.Inventory.Cost, 
    ]),
    [Name.Common.FormId]: Code.Form.Id.PURCHASE,
    [Name.Common.CommonId]: purchaseId,
  });
  await API.Data.List<ItemInventory>(url, setItemInventoryData, setError, setLoading);
};

useEffect(()=>{
  if(itemInventoryData){
    setFormData((prev) => ({
      ...prev,
      purchase_count: itemInventoryData.length,
    }));
  }
},[itemInventoryData])

const addItem = async () => {
  
  let productId: number | null = 2;

  const company_id = Utility.Storage.CompanyId();
  const location_id = Utility.Storage.LocationId();
  const user_id = Utility.Storage.UserId();
  const purchase_id = formData.purchase_id;
  const baseData = { company_id, location_id, user_id, productId };

  if(localSkucode){
    productId = 2
    let productName = ''
    let utnCode = ''
    let skuCode = ''
    let inventoryId = 2;
    let salePrice = 0;
    const fields = Utility.Join.Fields([
      Name.Inventory.SKU,
      Name.Inventory.UTN,
      Name.Inventory.SerialNo,
      Name.Inventory.Sale,
      Name.Product.Id,
    ]);

    const inventoryData = await API.Data.GetInventoryBySearch(Name.Inventory.SKU, localSkucode, fields);
    if(inventoryData){
        console.log("inventoryData------>",inventoryData);
        utnCode = inventoryData.inventory_utncode || '';
        skuCode = inventoryData.inventory_skucode || '';
        productId = inventoryData.product_id || 2;
        inventoryId = inventoryData.inventory_id || inventoryId;
        salePrice = inventoryData.inventory_sale_price || 0;

        const productData = await API.Data.GetProduct(productId);
        if(productData){
            console.log("productData------>",productData);
            productName = productData.product_name || '';
        }
    }

    // if(skuCode.length>0){
    //   Utility.Message.Warning(["This SKU/UTN Code is already associated with another purchase invoice"],setMessage);
    //   return;
    // }

    const finalItem: Item = { 
      ...emptyItem, 
      ...baseData,
      item_date: Utility.Date.Current(),
      form_id: Code.Form.Id.PURCHASE,
      common_id: formData.purchase_id,
      stock_status_id: 1,
      item_utncode: utnCode,
      item_skucode: skuCode,
      inventory_id: inventoryId,
      item_price: salePrice,
      item_quantity: 1,
      item_gross_amount: salePrice,
      item_net_amount: salePrice,
      ...(productId !== 0 && {
        product_id: productId,
      }),
    };

    const response = await API.Data.Save(Code.Form.Name.ITEM, Code.Key.NEW, finalItem, setMessage, true, Code.Form.PopupClose.REMAINOPEN)
    if(response){
      onRefresh();
      Utility.Message.Info(["Product added successfully"],setMessage);
      setSelectedProduct({value: 0, label: 'Select'});
      setLocalSkucode('');
    }

  }
  else {
    if (selectedProduct) {
      
      productId = selectedProduct.value;

      const itemData: Item = {
        ...baseData,
        form_id: Code.Form.Id.PURCHASE,
        common_id: formData.purchase_id,
        item_skucode: localSkucode,
        item_quantity: 1,
        stock_status_id: 1,
        product_id: productId
      };

      const inventoryData: Inventory = {
        ...baseData,
        product_id: productId,
        inventory_skucode: localSkucode,
      };

      const response = await API.Data.SaveItemInventory(Code.Key.NEW, Code.Key.NEW, itemData, inventoryData, Code.Form.PopupClose.REMAINOPEN);
      if(response){
        onRefresh();
        Utility.Message.Info(["Product added successfully"],setMessage);
        setSelectedProduct({value: 0, label: 'Select'});
        setLocalSkucode('');
      }


    }
    else {
      Utility.Message.Warning(["Select a product name or add UTN Number"],setMessage);
      return;
    }
  }
  
};

  type InventoryTotals = {
    gross: number;
    discount: number;
    tax: number;
    net: number;
  };

  const getItemInventoryTotals = (data: ItemInventory[]): InventoryTotals => {
    console.log("data----->",data);
    return data.reduce<InventoryTotals>(
      (totals, item) => {
        totals.gross += item.item_gross_amount ?? 0;
        totals.discount += item.item_discount_amount ?? 0;
        totals.tax += item.item_tax1_amount ?? 0;
        totals.net += item.item_net_amount ?? 0;
        return totals;
      },
      { gross: 0, discount: 0, tax: 0, net: 0}
    );
  };

  const calculateFunction = (itemInventoryData: Inventory[]) => {
    const totals = getItemInventoryTotals(itemInventoryData);

    setFormData((prev) => ({
      ...prev,
      ...(totals.gross > 0 && { purchase_gross_amount: Number(totals.gross.toFixed(2)) }),
      ...(totals.discount > 0 && { purchase_discount_amount:  Number(totals.discount.toFixed(2))}),
      ...(totals.tax > 0 && { purchase_tax1_amount: Number(totals.tax.toFixed(2)) }),
      ...(totals.net > 0 && { purchase_net_amount: Number(totals.net.toFixed(2)) }),
    }));

  };

  useEffect(() => {
    const tax1amount = formData.purchase_tax1_amount || 0;
    if(tax1amount > 0){
      const grossAmount = formData.purchase_gross_amount || 0;
      const discountAmount = formData.purchase_discount_amount || 0;
      const netAmount = (Number(grossAmount) - Number(discountAmount)) + Number(tax1amount);
       console.log("Tax1Amount changed:", grossAmount, discountAmount, tax1amount, netAmount);
      if(netAmount>0){
        setFormData((prev) => ({
          ...prev,
          purchase_net_amount: netAmount
        }));
      }
      
    }
    
  }, [formData.purchase_tax1_amount]);
  

  useEffect(() => {
    if (itemInventoryData && itemInventoryData.length > 0) {
      calculateFunction(itemInventoryData);
    }
  }, [itemInventoryData]);

  const addMultipleItems = async() => {
    const purchaseCount = formData.purchase_count || 0;
    const purchaseGroup = formData.purchase_group || 0;

    if(purchaseGroup <= purchaseCount){
      Utility.Message.Warning(["The number of new items should be more than the current number of items."],setMessage);
      return;
    }

    const missingItems = Number(purchaseGroup) - Number(purchaseCount);
    if(missingItems <= 0) return;
    if(!itemInventoryData) return;
    
    const length = itemInventoryData.length;
    if(length==0) return;

    const lastItem = itemInventoryData[length-1];
    if(!lastItem) return;
      
    const itemId = lastItem.item_id;
    if(!itemId || itemId<=9) return;

    const localItemData = await API.Data.GetById<Item>(Code.Form.Name.ITEM, itemId)
    if(!localItemData) return;

    console.log("localItemData--)))))--->",localItemData);

    const inventoryId = localItemData.inventory_id || 0;

    if(inventoryId == 0) return;
    
    const localInventoryData = await API.Data.GetById<Inventory>(Code.Form.Name.INVENTORY, inventoryId)
    if(!localInventoryData) return;

    console.log("localInventoryData--)))))--->",localInventoryData);
   
    const userId = Utility.Storage.UserId();

    // itemInvData.item_id = undefined;
    // itemInvData.inventory_id = undefined;
    // itemInvData.item_key = undefined;
    // itemInvData.inventory_key = undefined;
    // itemInvData.item_skucode = undefined;
    // itemInvData.inventory_skucode = undefined;
    // itemInvData.item_date = new Date();
    // itemInvData.inventory_date = new Date();
    // itemInvData.order_status_id = 2;
    // itemInvData.stock_status_id = 2;
    // itemInvData.user_id = userId;
    // itemInvData.item_history = '';
    // itemInvData.item_comment = '';
    // itemInvData.inventory_serialno = '';

    localItemData.item_id = undefined;
    localItemData.inventory_id = undefined;
    localItemData.item_key = undefined;
    localItemData.item_skucode = undefined;
    localItemData.item_date = new Date();
    localItemData.order_status_id = 2;
    localItemData.stock_status_id = 2;
    localItemData.user_id = userId;
    localItemData.item_history = '';
    localItemData.item_comment = '';
   
    localInventoryData.inventory_id = undefined;
    localInventoryData.inventory_key = undefined;
    localInventoryData.inventory_utncode = undefined;
    localInventoryData.inventory_skucode = undefined;
    localInventoryData.inventory_date = new Date();
    localInventoryData.user_id = userId;
    localInventoryData.inventory_serialno = '';
    
    // const localItemData = Utility.Get.ModelFields<Item>(itemInvData, itemKeys);
    // const localInventoryData = Utility.Get.ModelFields<Inventory>(itemInvData, inventoryKeys);

    // localInventoryData.inventory_id = undefined;

    // console.log("localItemData----->",localItemData);
    // console.log("localInventoryData----->",localInventoryData);
    // console.log("missingItems----->",missingItems);
  
    for (let item = 0; item < missingItems; item++) {
      const response = await API.Data.SaveItemInventory(Code.Key.NEW, Code.Key.NEW, localItemData, localInventoryData, Code.Form.PopupClose.REMAINOPEN);
      console.log("missingItems-response----->",response);
      if(response){
        //if require, new UtnCode can be returned.
      }
    }

    Utility.Message.Info([`${missingItems} Products added successfully`],setMessage);
    onRefresh();
  };


  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });
    
    const response = await API.Data.Save(formName, keyId, finalData, setMessage,true, Code.Form.PopupClose.REMAINOPEN);
    if(response){
      if(keyId===Code.Key.NEW){
        const localKeyId = response.data[Code.Key.NEWID];
        const localNewId = Extract.Key.Decode(localKeyId);
        setKeyId(localKeyId);
        setActiveId(Code.Option.Active.ACTIVE);
        Utility.Storage.Set(Code.Form.Name.PURCHASE,localNewId);
        setFormData((prev) => ({
          ...prev,
          purchase_id: localNewId,
          purchase_key: localKeyId,
        }));
      }
    }
  };

  const onRefresh = () => {
    console.log("refreshed");
    const PurchaseId = Utility.Storage.Get(Code.Form.Name.PURCHASE);
    if(PurchaseId){
      callItemList(Number(PurchaseId));
    }
  };

  const verifyPurchase = async () => {
    const PurchaseId = formData.purchase_id;
    console.log("verify Purchase:", PurchaseId);
    if(PurchaseId && PurchaseId>0){
      const response = await API.Data.verifyPurchase(PurchaseId, setMessage);
      if(response){
        console.log(`Purchase verified response:`, response);
        const retult = response.newid;
        console.log(`Purchase verified code:`, retult);
        if(retult == 'Success'){
          Utility.Message.Info([`Purchase has been verified, and the SKU code has been generated.`],setMessage);
          await onRefresh();
        }
        else{
          Utility.Message.Warning([`Purchase verification failed.`],setMessage);
        }
        
      }
    }
    
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      Utility.Storage.Delete(Code.Form.Name.PURCHASE);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} print={true}>
            <Button.Action title={'Verify'} info={'Verify this purchase invoice with generate SKU(s)'} onClick={verifyPurchase} visible={keyId !== Code.Key.NEW} enable={true || Privilege.APPROVE} />
          </Button.Save>
          <Control.Tab.Header titles={["Details", "More"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Purchase.Date} value={formData.purchase_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} require={true} currentDate={true} />
                <Field.Text id={Name.Purchase.Number} value={formData.purchase_number} title={Title.InvoiceNo} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,20,1]} require={true} />
                <Field.FilterSelect id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions} setFormData={setFormData} size={[1,20,1]} />
                <Field.FilterSelect id={Name.Common.SegmentId} value={formData.segment_id} title={Title.Segment} options={segmentOptions} setFormData={setFormData} require={true} size={[1,20,1]} defaultValue={Code.Option.Segment.OPTICAL} />
                <Field.FilterSelect id={Name.Common.StatusId} value={formData.status_id} title={Title.State} options={statusOptions} setFormData={setFormData} size={[1,20,0]} />
              </Control.Row>
              <Control.Box>
                <Field.FilterSelect id={Name.Supplier.Id} value={formData.supplier_id} title={Title.Supplier} options={supplierOptions} setFormData={setFormData} require={true} />
              </Control.Box>
              <Control.Row>
                <Field.Header id={Name.Product.Id} title={Title.Product} size={[0,40,1]}>
                  <AsyncSelect id={Name.Product.Id} value={selectedProduct} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.PRODUCT, Code.Mapping.product.value, Code.Mapping.product.label)} styles={Code.Style.FormOption} onChange={(selected) => setSelectedProduct(selected as OptionType | null)} placeholder="Search" />
                </Field.Header>
                <Field.Text id={Name.Item.SKU} value={localSkucode} title={Title.Utncode} onChange={(e) => setLocalSkucode(e.target.value)} size={[1,20,1]} />
                <Button.FrameAction title="+" info={Info.AddProduct} onClick={addItem} size={[1,20,1]} className='pt6' disable={keyId===Code.Key.NEW ? true : false} />
              </Control.Row>
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Grid.Items values={[
                    [Title.Product, width.product], 
                    [Title.Skucode, width.skucode], 
                    [Title.Utncode, width.utncode], 
                    ["Wholesale", width.purchase, Code.Align.RIGHT],
                    [Title.Cost, width.cost, Code.Align.RIGHT]
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {itemInventoryData?.map((item, index) => (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Grid.Modify path={Utility.Join.Edit(Privilege, Code.Form.Name.PURCHASE, Code.Form.Name.ITEM, item.item_key)} iframeRef={iframeRef} Privilege={Privilege} />
                        <Control.Grid.Items values={[
                          [item.product_name, width.product],
                          [item.item_skucode, width.skucode],
                          [item.item_utncode, width.utncode],
                          [Utility.Format.Amount(item.inventory_purchase_price), width.purchase, Code.Align.RIGHT],
                          [Utility.Format.Amount(item.inventory_cost_price), width.cost, Code.Align.RIGHT],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  ))}
                </Control.Form.List>
              </Control.Form.Table>
              <Control.Flex>
                <Control.Column size={[0,15,0,2]}>
                  <Control.Row>
                    <Field.Number id={Name.Purchase.Count} value={formData.purchase_count}  title="Count" onChange={(e) => Form.Field.Change(e, formData, setFormData)} align={Code.Align.CENTER} />
                  </Control.Row>
                </Control.Column>
                <Control.Column size={[0,35,0,3]}><></></Control.Column>
                <Control.Column size={[0,50,0,1]}>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount id={Name.Purchase.Gross} value={formData.purchase_gross_amount} title={Title.Gross} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} />
                    <Field.Amount id={Name.Purchase.DiscountAmount} value={formData.purchase_discount_amount} title={Title.Discount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]}  />
                    {/* <Field.Number id={Name.Purchase.DepositAmount} value={formData.purchase_deposit_amount} title={Title.Deposit} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,16,0]} /> */}
                  </Control.Row>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    {/* <Field.Number id={Name.Purchase.TaxableAmount} value={formData.purchase_taxable_amount} title={Title.Taxable} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,16,1]} /> */}
                    <Field.Amount id={Name.Purchase.Tax1Amount} value={formData.purchase_tax1_amount} title={Title.Tax} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]}  />
                    <Field.Amount id={Name.Purchase.NetAmount} value={formData.purchase_net_amount} title={Title.NetAmount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]}  />
                  </Control.Row>
                  {/* <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount id={Name.Purchase.Roundoff} value={formData.purchase_roundoff_amount} title={Title.Roundoff} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} />
                    <Field.Amount id={Name.Purchase.NetAmount} value={formData.purchase_net_amount} title={Title.Payable} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]}  />
                  </Control.Row> */}
                </Control.Column>
              </Control.Flex>
            </Control.Tab.Content>
            
            <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              <Control.Row>
                <Field.Text id={Name.Purchase.RefNo} value={formData.purchase_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} />
              </Control.Row>
              <Control.Row>
                <Field.Title title="Number of products with same specifications" />
              </Control.Row>
              <Control.Row>
                <Field.Number id={Name.Purchase.Group} value={formData.purchase_group}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]}  />
                <Control.ButtonColumn size={[15,1,0,0,0]} align={Code.Align.LEFT}>
                  <Button.Action title={'Add Items'} info={Info.AddProduct} onClick={addMultipleItems} />
                </Control.ButtonColumn>
              </Control.Row>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} print={true} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={onRefresh} />
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default PurchaseForm;